var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpeninline = function SvgOpeninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#7D64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 45c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 2.602.663 5.05 1.828 7.182v5.959h5.933A14.932 14.932 0 0 0 30 45Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.139 32.625c0-2.333 3.861-2.333 3.861-5.639C35 24.847 33.119 23 30.05 23 26.09 23 25 26.208 25 26.208l2.574 1.167s.693-1.556 2.475-1.556c1.09 0 1.783.681 1.783 1.362 0 1.555-3.466 1.944-3.466 4.569 0 .486.198.875.198.875h2.575Zm-2.97 2.82c0 .874.692 1.555 1.584 1.555.89 0 1.584-.68 1.584-1.556 0-.875-.693-1.555-1.584-1.555-.892 0-1.585.68-1.585 1.555Z",
    fill: "#7D64FF"
  })));
};
export default SvgOpeninline;